// Copyright (c) 2020-2021, 2023 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { Switch, Route, RouteComponentProps } from 'react-router-dom';

import { HeaderConfig } from '@modules/Private/components/Header';
import ModuleWrapper from '@shared/components/ModuleWrapper';
import DataManagementChoice from './pages/DataManagementChoice';

export interface DataManagementProps extends RouteComponentProps {
  setHeaderConfig: (config: HeaderConfig) => any;
}

export enum FunctionType {
  import = 'import',
  export = 'export',
  report = 'report',
  sync = 'sync',
}

// Component for the File Import/Export/Report page.
class DataManagement extends React.Component<DataManagementProps> {
  constructor(props: DataManagementProps) {
    super(props);

    props.setHeaderConfig({
      moduleName: 'File',
    });
  }

  render() {
    const { match } = this.props;

    return (
      <ModuleWrapper>
        <Switch>
          <Route 
            exact
            // path={`${match.url}/:functionType(${FunctionType.export}|${FunctionType.import}|${FunctionType.report})?`}
            path={`${match.url}/:functionType?`}
            render={(props) => <DataManagementChoice {...props} rootURL={match.url} />}
          />
        </Switch>
      </ModuleWrapper>
    );
  }
}

export default DataManagement;
